import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Clock, LayoutDashboard, FileText, Tag, School, HeartHandshake, LogOut, Ticket, Settings, UserCog } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/super", end: true, icon: LayoutDashboard, label: "Overview" },
  { to: "/super/cms", icon: FileText, label: "Homepage CMS" },
  { to: "/super/plans", icon: Tag, label: "Plans" },
  { to: "/super/schools", icon: School, label: "Schools" },
  { to: "/super/parents", icon: HeartHandshake, label: "Parents" },
  { to: "/super/vouchers", icon: Ticket, label: "Vouchers" },
  { to: "/super/team", icon: UserCog, label: "Team", fullOnly: true },
  { to: "/super/settings", icon: Settings, label: "Platform", fullOnly: true },
];

export default function SuperLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const nav = NAV.filter((n) => !n.fullOnly || !user || user.level !== "support");

  return (
    <div className="min-h-screen flex" data-testid="super-layout">
      <aside className="w-16 lg:w-64 shrink-0 border-r-2 border-zinc-900 bg-zinc-900 text-white flex flex-col">
        <div className="p-4 border-b-2 border-zinc-700 flex items-center gap-2">
          <div className="w-9 h-9 shrink-0 rounded-xl border-2 border-zinc-900 bg-[#A7E4D3] flex items-center justify-center">
            <Clock className="w-5 h-5 text-zinc-900" />
          </div>
          <div className="hidden lg:block">
            <div className="font-display font-black text-lg leading-tight">MyTimetable.co.uk</div>
            <div className="text-xs text-zinc-400">Super admin</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`super-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-3 py-2.5 font-bold text-sm border-2 transition-colors duration-150 ${
                  isActive ? "bg-[#A7E4D3] text-zinc-900 border-zinc-900 shadow-[3px_3px_0px_0px_#A7E4D3]" : "border-transparent text-zinc-300 hover:bg-zinc-800"
                }`
              }>
              <n.icon className="w-5 h-5 shrink-0" />
              <span className="hidden lg:inline">{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t-2 border-zinc-700">
          <button onClick={() => { logout(); navigate("/"); }} data-testid="super-logout-btn"
            className="w-full flex items-center gap-2 rounded-xl px-3 py-2 font-bold text-sm text-zinc-400 hover:bg-zinc-800 transition-colors duration-150">
            <LogOut className="w-4 h-4 shrink-0" />
            <span className="hidden lg:inline">Log out</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 lg:p-10">
        <Outlet />
      </main>
    </div>
  );
}
